<template>
 <div>
   <el-dialog title="" :visible.sync="dialogFormVisible" @close="closeDialog">
    <div class="dialogTitle">{{title}}</div>
    <div class="dialogBody">
      <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic" :rules="rules" :inline="false" label-position="top">
        <el-form-item prop="oldPass" label="原密码">
          <el-input placeholder="请输入原密码" v-model="dynamicValidateForm.oldPass" show-password></el-input>
        </el-form-item>
        <el-form-item prop="newPass" label="新密码">
          <el-input placeholder="请输入新密码" v-model="dynamicValidateForm.newPass" show-password></el-input>
        </el-form-item>
        <el-form-item prop="newPass2" label="确认密码">
          <el-input placeholder="请输入新密码" v-model="dynamicValidateForm.newPass2" show-password></el-input>
        </el-form-item>
      </el-form>
      <div class="btns">
        <div class="greyBtn" @click="closeDialog">取消</div>
        <div class="blueBtn" @click="submitForm('dynamicValidateForm')">确定修改</div>
      </div>
    </div>

  </el-dialog>
  <!--反馈弹窗-->
  <SmallDialog ref="smallDialog" tip="修改成功" type="2" tit="修改密码"></SmallDialog>
 </div>

</template>
<script>
const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
    '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
 import JSEncrypt from 'jsencrypt/bin/jsencrypt'
 import SmallDialog from './smallDialog.vue'
 import {
    fetchChangePass
  } from '@/api/api'
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else {
                if (this.dynamicValidateForm.newPass2 !== "") {
                    this.$refs.dynamicValidateForm.validateField("newPass2");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else if (value !== this.dynamicValidateForm.newPass) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
      return {
        title: '修改密码',
        dialogFormVisible: false,
        dynamicValidateForm: {
          oldPass: '',
          newPass: '',
          newPass2: '',
        },
        rules: {
          oldPass: [
             { required: true, message: '请输入原密码', trigger: 'blur' }
          ],
          newPass: [
             { required: true, message: '请输入新密码', trigger: 'blur' },
             { validator: validatePass, trigger: ["blur"] }
          ],
          newPass2: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            {
              validator: validatePass2, trigger: ["blur"]
            }
          ]

        }
      };
    },
    components: {
      SmallDialog
    },
    created() {
    },
    methods: {
      setEncrypt: function(publicKey, data) {
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);

        return encrypt.encrypt(data);
      },
      closeDialog() {
         this.dialogFormVisible= false
         this.resetForm('dynamicValidateForm')
      },
      openDialog(val) {
        this.dialogFormVisible= true
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let { newPass, oldPass } = this.dynamicValidateForm
            let params = {
              oldPass: this.setEncrypt(publicKey, oldPass),
              newPass: this.setEncrypt(publicKey, newPass)
            }
            fetchChangePass(params).then(res => {
              if(res.code === 0) {
                this.$message.error(res.data);
              }else {
                this.closeDialog()
                this.$refs.smallDialog.openDialog()
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style scoped>
.dialogTitle{
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0A0909;
  text-align: center;
  padding-bottom: 30px;
}
/deep/ .el-dialog{
  border-radius: 20px;
}
/deep/ .el-input{
  border: 1px solid rgba(215, 220, 227, 1);
  border-radius: 4px;
}
.dialogBody{
  padding: 0 70px;
}
.btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 60px;
}
.greyBtn{
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #A7AFC3;
  line-height: 45px;
  width: 220px;
  height: 45px;
  background: #E8EDF6;
  border-radius: 23px;
  text-align: center;
  cursor: pointer;
}
.blueBtn{
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  width: 220px;
  height: 45px;
  background: #0F5EFF;
  border-radius: 23px;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePass.vue